import React, { useContext, useEffect, useRef } from "react";
import { message } from "antd";
import { AppFooter } from "../components";
import { PublicAppHeader } from "../components/PublicAppHeader";
import AuthContext from "../../context/AuthContext";
import Styles from "./PublicLayout.module.css";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const PublicLayout = ({ children }: Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isError, isSuccess } = useContext(AuthContext);
  const hasSucceded = useRef(false);
  const hasFailed = useRef(false);

  useEffect(() => {
    if (isSuccess.status && !hasSucceded.current) {
      success(isSuccess.message);
      hasSucceded.current = true;
    }
  }, [isSuccess.status]);

  useEffect(() => {
    if (isError.status && !hasFailed.current) {
      error(isError.message);
      hasFailed.current = true;
    }
  }, [isError]);

  useEffect(() => {
    if (isError.status && !hasFailed.current) {
      error(isError.message);
      hasFailed.current = true;
    }
  }, [isError]);

  const error = (message: string) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const success = (message: string) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };
  return (
    <div className={Styles.public_layout}>
      {contextHolder}
      <PublicAppHeader />
      <main className={Styles.public_layout__content__children}>{children}</main>
      <AppFooter />
    </div>
  );
};
